import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import appscreen from "../../assets/images/appscreen.png";
import Application from "../../assets/images/applicationvideothumb.png";
import Playbtn from "../../assets/images/play_white.svg";
import Videobtn from "../../assets/images/playvideotext.png";
import Mobileicon from "../../assets/images/mobileicon.png";
import Usericon from "../../assets/images/usericon.png";
import Magneticon from "../../assets/images/magnet.png";

function About() {
  const [counts, setCounts] = useState({
    download: 0,
    reviews: 1500,
    countries: 0,
    followers: 0,
  });

  useEffect(() => {
    const targetCounts = {
      download: 17,
      reviews: 2300,
      countries: 150,
      followers: 8,
    };
    const duration = 1500;
    const stepSize = 10;
    const steps = duration / stepSize;

    const intervals = Object.keys(targetCounts).map((key) => {
      const targetCount = targetCounts[key];
      const currentCount = counts[key];
      const step = Math.ceil((targetCount - currentCount) / steps);

      if (step !== 0) {
        const interval = setInterval(() => {
          setCounts((prevCounts) => {
            if (prevCounts[key] + step >= targetCount) {
              clearInterval(interval);
              return { ...prevCounts, [key]: targetCount };
            }
            return { ...prevCounts, [key]: prevCounts[key] + step };
          });
        }, stepSize);
        return interval;
      }
      return null;
    });

    return () => {
      intervals.forEach((interval) => interval && clearInterval(interval));
    };
  }, [counts]);

  const [ytshow, setytShow] = useState(false);

  return (
    <>
      <section id="about" className="about_section row_am">
        <div className="container">
          <div
            className="section_title"
            data-aos="fade-up"
            data-aos-duration={1500}
          >
            <span className="title_badge mb-1">À propos</span>
            <h2>
              <span>
                L’application
                <img src={Mobileicon} alt="" />
              </span>{" "}
              qui t’aide à{" "}
              <span>
                te comprendre
                <img src={Usericon} alt="" />
              </span>{" "}
              et à{" "}
              <span>
                construire
                <img src={Magneticon} alt="" />
              </span>{" "}
              ton avenir
            </h2>
          </div>
          <div className="row">
            <div className="col-lg-4 col-md-6">
              <ul
                className="app_statstic"
                id="counter"
                data-aos="fade-in"
                data-aos-duration={1500}
              >
                <li data-aos="fade-up" data-aos-duration={1500}>
                  <div className="text">
                    <p>
                      <span className="counter-value">50K</span>
                      <span>+</span>
                    </p>
                    <p>Personnes intéressées</p>
                  </div>
                </li>
                <li data-aos="fade-up" data-aos-duration={1500}>
                  <div className="text">
                    <p>
                      <span className="counter-value">1K</span>
                      <span>+</span>
                    </p>
                    <p>Feedbacks récoltés</p>
                  </div>
                </li>
                <li data-aos="fade-up" data-aos-duration={1500}>
                  <div className="text">
                    <p>
                      <span className="counter-value">20</span>
                      <span>+</span>
                    </p>
                    <p>Partenaires en onboarding</p>
                  </div>
                </li>
                <li data-aos="fade-up" data-aos-duration={1500}>
                  <div className="text">
                    <p>
                      <span className="counter-value">100</span>
                      <span>%</span>
                    </p>
                    <p>Parcours personnalisés</p>
                  </div>
                </li>
              </ul>
            </div>
            <div className="col-lg-4 col-md-6">
              <div
                className="abtImg text-center"
                data-aos="fade-up"
                data-aos-duration={1500}
              >
                <img src={appscreen} alt="" />
              </div>
            </div>
            <div className="col-lg-4 align-self-center">
              <p data-aos="fade-up" data-aos-duration={1500}>
                Neoori combine des tests intelligents, un profil personnalisé et
                un coach IA pour t’aider à révéler ton potentiel. En quelques
                minutes, tu comprends mieux tes forces, ton style, et les
                opportunités qui te correspondent — sans stress, sans pression,
                juste toi.
              </p>
              <div
                className="btn_block mt-4"
                data-aos="fade-up"
                data-aos-duration={1500}
              >
                <Link to="/contact" className="btn puprple_btn ml-0">
                  Découvre comment Neoori t’accompagne
                </Link>
                <div className="btn_bottom" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {ytshow && (
        <div
          className="modal fade youtube-video show"
          id="myModal"
          tabIndex={-1}
          style={{ display: "block", paddingRight: 17 }}
          aria-modal="true"
          role="dialog"
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content" onClick={() => setytShow(false)}>
              <button
                id="close-video"
                type="button"
                className="button btn btn-default text-right"
                data-dismiss="modal"
                onClick={() => setytShow(false)}
              >
                <i className="icofont-close-line-circled" />
              </button>
              <div className="modal-body">
                <div id="video-container" className="video-container">
                  <iframe
                    id="youtubevideo"
                    title="Youtube Video Player"
                    width={640}
                    height={360}
                    allowFullScreen=""
                    src="https://www.youtube.com/embed/tgbNymZ7vqY?autoplay=1&mute=1"
                  />
                </div>
              </div>
              <div className="modal-footer"></div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default About;
